module.exports = __webpack_public_path__ + "img/banner-mob.646c5019.jpg";